import { AngularRoutesEnum, DojoRoutesEnum, NavigationBase } from "@core/layout/enums/layout-routes.enum";
import { SideNavItem } from "@core/layout/components/side-nav/models/side-nav-item.model";
import { LinkUtils } from "@core/layout/utils/link.utils";
import { SideNavIds } from "@core/layout/components/side-nav/enums/side-nav-ids.enum";

export const SIDE_NAV_ITEMS: SideNavItem[] = [
	{
		id: SideNavIds.ACCUEIL,
		icon: "home-alt",
		label: "Accueil",
		link: LinkUtils.generateLinkModel(NavigationBase.DOJO, DojoRoutesEnum.DASHBOARD),
	},
	{
		id: SideNavIds.ORDONNANCES,
		icon: "file-heart",
		label: "Ordonnances",
		link: null,
		enfants: [
			{
				id: SideNavIds.ORDONNANCES_LISTE,
				icon: null,
				label: "Ordonnances",
				link: LinkUtils.generateLinkModel(NavigationBase.DOJO, [
					DojoRoutesEnum.ORDONNANCES,
					DojoRoutesEnum.LISTE_ORDONNANCES,
				]),
			},
			{
				id: SideNavIds.ORDONNANCES_PRESCRIPTION_IPA,
				icon: null,
				label: "Prescription IPA",
				link: LinkUtils.generateLinkModel(NavigationBase.DOJO, [
					DojoRoutesEnum.ORDONNANCES,
					DojoRoutesEnum.LISTE_SYNAPSE,
				]),
			},
		],
	},
	{
		id: SideNavIds.CABINET,
		icon: "home-med",
		label: "Cabinet",
		link: null,
		enfants: [
			{
				id: SideNavIds.CABINET_PLANNING,
				icon: null,
				label: "Planning",
				link: LinkUtils.generateLinkModel(NavigationBase.DOJO, [
					DojoRoutesEnum.PLANNING_AGENDA,
					DojoRoutesEnum.PLANNING,
				]),
			},
			{
				id: SideNavIds.CABINET_REMPLACANTS,
				icon: null,
				label: "Remplaçants",
				link: LinkUtils.generateLinkModel(NavigationBase.DOJO, [
					DojoRoutesEnum.REMPLACANTS,
					DojoRoutesEnum.LISTE_REMPLACANTS,
				]),
			},
		],
	},
	{
		id: SideNavIds.PAIEMENT,
		icon: "euro-circle",
		label: "Paiement",
		link: null,
		enfants: [
			{
				id: SideNavIds.PAIEMENT_FACTURES,
				icon: null,
				label: "Factures",
				link: LinkUtils.generateLinkModel(NavigationBase.DOJO, [
					DojoRoutesEnum.FACTURATION,
					DojoRoutesEnum.FACTURES,
				]),
			},
			{
				id: SideNavIds.PAIEMENT_EFACTURES,
				icon: null,
				label: "E-Factures",
				link: LinkUtils.generateLinkModel(NavigationBase.ANGULAR, AngularRoutesEnum.E_FACTURES),
			},
			{
				id: SideNavIds.PAIEMENT_TELETRANSMISSIONS,
				icon: null,
				label: "Télétransmissions",
				link: LinkUtils.generateLinkModel(NavigationBase.DOJO, [
					DojoRoutesEnum.TELETRANSMISSION,
					DojoRoutesEnum.HISTORIQUE,
				]),
			},
			{
				id: SideNavIds.PAIEMENT_MES_REGLEMENTS,
				icon: null,
				label: "Mes règlements",
				link: LinkUtils.generateLinkModel(NavigationBase.DOJO, [
					DojoRoutesEnum.COMPTA,
					DojoRoutesEnum.LISTE_REGLEMENTS,
				]),
			},
			{
				id: SideNavIds.PAIEMENT_REJETS,
				icon: null,
				label: "Mes rejets",
				link: LinkUtils.generateLinkModel(NavigationBase.DOJO, [
					DojoRoutesEnum.TELETRANSMISSION,
					DojoRoutesEnum.REJETS_AY,
				]),
			},
		],
	},
	{
		id: SideNavIds.PATIENTELE,
		icon: "user-square",
		label: "Patientèle",
		link: null,
		enfants: [
			{
				id: SideNavIds.PATIENTELE_PATIENTS,
				icon: null,
				label: "Patients",
				link: LinkUtils.generateLinkModel(NavigationBase.DOJO, [
					DojoRoutesEnum.PATIENTS,
					DojoRoutesEnum.LISTE_PATIENTS,
				]),
			},
			{
				id: SideNavIds.PATIENTELE_AGENDA,
				icon: null,
				label: "Agenda",
				link: LinkUtils.generateLinkModel(NavigationBase.DOJO, [
					DojoRoutesEnum.PLANNING_AGENDA,
					DojoRoutesEnum.AGENDA,
				]),
			},
			{
				id: SideNavIds.PATIENTELE_COORDINATION,
				icon: null,
				label: "Coordination",
				link: LinkUtils.generateLinkModel(NavigationBase.ANGULAR, AngularRoutesEnum.DOSSIER_DE_SOINS),
			},
		],
	},
];
